module.exports = __webpack_public_path__ + "static/media/Archivo_001.0d625446.jpeg";